export const MIN_NAME_LENGTH = 5
export const MAX_NAME_LENGTH = 256

export function getDocumentPrefix(docType: PepperDocTypes, suffix?: string) {
  const prefix = (() => {
    switch (docType) {
      case 'PEPPER_DOC':
      case 'PUBLIC_VIEW_PEPPER_DOC':
        return 'Assignment'
      case 'BRIEF':
        return 'Creative Briefs'
      case 'PRIVATE_DOC':
      case 'PRIVATE_ITEM_PUBLIC_VIEW_PEPPER_DOC':
        return 'Projects'
      case 'TEMPLATE':
        return 'Template'
      case 'NOTE':
        return null
      default:
        return 'Document'
    }
  })()
  if (prefix === null) return null
  return `${prefix}  ${suffix}`
}

export function isDocTitleEditable({
  platform,
  docType,
}: {
  platform: Platforms
  docType: PepperDocTypes
}) {
  switch (platform) {
    case 'business':
      return ['BRIEF', 'PRIVATE_DOC', 'TEMPLATE', 'NOTE'].includes(docType)
    case 'creators':
      return false
    case 'operations':
      return ['BRIEF'].includes(docType)
    default:
      return false
  }
}
